module.exports = __webpack_public_path__ + "img/sintesis.c8d8a35b.svg";